import { SelectOption } from 'types/common/select';
import { ConfirmSellerInfoSort, SellerStatus } from 'types/marketplace/confirmSellerInfo';

export const sellerStatusLabel = {
  [SellerStatus.PENDING]: 'Pending',
  [SellerStatus.CONFIRMED]: 'Confirmed',
  [SellerStatus.REJECTED]: 'Rejected',
  [SellerStatus.PAUSED]: 'Paused',
};

export const sellerStatusBulletColor = {
  [SellerStatus.PENDING]: '#FFD54D',
  [SellerStatus.CONFIRMED]: '#49CE8F',
  [SellerStatus.REJECTED]: '#f53e3e',
  [SellerStatus.PAUSED]: '#7a7979',
};

export const sortOptions: SelectOption[] = [
  { value: ConfirmSellerInfoSort.UPDATED_DATE, label: 'Updated date' },
  { value: ConfirmSellerInfoSort.CLOSET_ID, label: 'CLOSET ID' },
  { value: ConfirmSellerInfoSort.NAME, label: 'Name' },
];
